import * as React from 'react'
import { Section } from '@shared/components/section'
import Link from 'next/link'
import styled from 'styled-components'

const Wrapper = styled.div(({ theme }) => ({
	marginBottom: 60,
	paddingLeft: 20,
	paddingRight: 20,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginBottom: 100,
		paddingLeft: 60,
		paddingRight: 60,
	},
}))

const Title = styled.h2(({ theme }) => ({
	...theme.typography.header30_36,
	marginBottom: 20,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.header56_60,
		marginBottom: 40,
	},
}))

const BlocksContainer = styled.div(({ theme }) => ({
	display: 'grid',
	gridTemplateColumns: '1fr',
	justifyContent: 'space-between',
	flexWrap: 'wrap', // Позволяет блокам переноситься на новую строку при малых экранах
	gap: '40px',

	[theme.mediaQueries.mediaMinWidthMobile]: {
		// Адаптация под мобильные устройства
		gridTemplateColumns: '1fr 1fr',
		gap: '60px',
	},
}))

const BlockWrapper = styled.div(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '20px',
}))

const Block = styled.div(() => ({
	backgroundColor: '#eaf6fa',
	borderRadius: 10,
	overflow: 'hidden',
	minHeight: 300,

	iframe: {
		border: 'none',
		height: '100%',
		width: '100%',
	},
}))

const Description = styled.p(() => ({
	fontSize: '16px',
	lineHeight: 1.5,
	color: '#333',
}))

const LinkA = styled(Link)(({ theme }) => ({
	color: theme.colors.main,
	textDecoration: 'none',
}))

export const SectionAboutDeposit = () => {
	return (
		<Section>
			<Wrapper>
				<Title>Наглядно про Сбережения</Title>
				<BlocksContainer>
					<BlockWrapper>
						<Block>
							<iframe
								src='https://vk.com/video_ext.php?oid=-106835626&id=456241761'
								allow='autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;'
								allowFullScreen
							/>
						</Block>
						<Description>
							Кира Юхтенко из{' '}
							<LinkA href='https://investfuture.ru/' target='_blank' rel='noopener noreferrer nofollow'>
								InvestFuture
							</LinkA>{' '}
							показывает на своём опыте как открыть Сбережение
						</Description>
					</BlockWrapper>
					<BlockWrapper>
						<Block>
							<iframe
								src='https://vk.com/video_ext.php?oid=-106835626&id=456241885&hd=1'
								allow='autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;'
								allowFullScreen
							/>
						</Block>
						<Description>
							Денис Сметнев, сооснователь SkyEng, рассказывает почему выбрал Сбережения как один из
							инвестиционных инструментов
						</Description>
					</BlockWrapper>
				</BlocksContainer>
			</Wrapper>
		</Section>
	)
}
